import { FunctionComponent } from "react";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";
import { StyledToolbarButton } from "../styles";

interface ToolbarButtonProps {
  className?: string;
  value?: string;
  icon?: FunctionComponent<any>;
  onClick?: () => void;
}

export const ToolbarButton = ({ icon, ...rest }: ToolbarButtonProps) => (
  <StyledToolbarButton theme={ITheme.tertiary} type="button" {...rest}>
    {icon && <Icon as={icon} size="l" />}
  </StyledToolbarButton>
);
